export default "__VITE_ASSET__CmKvEB_g__"